unit unit_Preise;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Vcl.Controls, WEBLib.Grids, Data.DB,
  XData.Web.JsonDataset, XData.Web.Dataset, Vcl.StdCtrls, WEBLib.StdCtrls, DB,
  WEBLib.ExtCtrls;

type
  TPreise = class(TForm)
    TC: TTableControl;
    xdsKundenpreise: TXDataWebDataSet;
    xdsKundenpreiseArtikelnummer: TXDataWebEntityField;
    xdsKundenpreiseKundennummer: TXDataWebEntityField;
    xdsKundenpreiseVerkaufspreis: TFloatField;
    xdsKundenpreiseNachname: TStringField;
    xdsKundenpreiseRabattsatz: TFloatField;
    xdsKundenpreiseVerleihpreis: TFloatField;
    xdsKundenpreiseZusatzPreis: TFloatField;
    xdsKundenpreiseArtikelnummerKunde: TStringField;
    xdsKundenpreiseDatumGeaendert: TDateTimeField;
    xdsKundenpreiseArtikelueberschrift: TStringField;
    xdsKundenpreiseArtikelnummerArtikelnummer: TStringField;
    xdsKundenpreiseArtikelnummerArtikelueberschrift: TStringField;
    xdsKundenpreiseArtikelnummerArtikelbeschreibung: TStringField;
    xdsLieferantenpreise: TXDataWebDataSet;
    xdsLieferantenpreiseArtikelnummer: TXDataWebEntityField;
    xdsLieferantenpreiseEinkaufspreis: TFloatField;
    xdsLieferantenpreiseNachname: TStringField;
    xdsLieferantenpreiseDatumGeaendert: TDateTimeField;
    xdsLieferantenpreiseArtikelnummerLieferant: TStringField;
    xdsLieferantenpreiseERabattsatz: TFloatField;
    xdsLieferantenpreiseMindestbestellmenge: TFloatField;
    xdsLieferantenpreiseKundennummer: TXDataWebEntityField;
    xdsLieferantenpreiseArtikelnummerArtikelnummer: TStringField;
    xdsLieferantenpreiseArtikelnummerArtikelueberschrift: TStringField;
    xdsLieferantenpreiseArtikelnummerArtikelbeschreibung: TStringField;
    Container1: THTMLContainer;
    btnzurueck: TButton;
    Container2: THTMLContainer;
    TCEinkauf: TTableControl;
    Container3: THTMLContainer;
    procedure WebFormShow(Sender: TObject);
    procedure xdsKundenpreiseAfterOpen(DataSet: TDataSet);
    procedure xdsLieferantenpreiseAfterOpen(DataSet: TDataSet);
    procedure btnzurueckClick(Sender: TObject);
  private
    { Private-Deklarationen }
  public
    { Public-Deklarationen }
    mykontaktnummer:string;
    mykontaktname:string;

  protected procedure LoadDFMValues; override; end;

var
  Preise: TPreise;

implementation
  uses unit1, unit2;
{$R *.dfm}

procedure TPreise.btnzurueckClick(Sender: TObject);
begin
  xdsKundenpreise.Close;
  xdsLieferantenpreise.Close;
  self.Close;
end;



procedure TPreise.WebFormShow(Sender: TObject);
var
  myelement:TJSHTMLElement;
begin
  Container1.html.text:='<nav class="navbar m-1 rounded bg-info"><h5>Preise für '+mykontaktname+' | '+mykontaktnummer +'</h5></nav>';
  myelement:=container1.ElementHandle;
  btnzurueck.ParentElement:=myelement;
  container2.ParentElement:=myelement;
  container3.ParentElement:=myelement;
  myelement:=container2.ElementHandle;
  tc.ParentElement:=myelement;
  myelement:=container3.ElementHandle;
  TCEinkauf.ParentElement:=myelement;
  xdsKundenpreise.Close;
  xdskundenpreise.QueryString:='$expand=Artikelnummer&$filter=Kundennummer eq '+QuotedStr(mykontaktnummer);
  xdsKundenpreise.Load;
end;

procedure TPreise.xdsKundenpreiseAfterOpen(DataSet: TDataSet);
begin
  xdsLieferantenpreise.Close;
  xdsLieferantenpreise.QueryString:='$expand=Artikelnummer&$filter=Kundennummer eq '+QuotedStr(mykontaktnummer);
  xdsLieferantenpreise.Load;
end;

procedure TPreise.xdsLieferantenpreiseAfterOpen(DataSet: TDataSet);
var
  i:integer;
  myelement:TJSHTMLElement;
begin
  i:=0;
  TC.ColCount:=3;
  TC.Rowcount:=xdsKundenpreise.RecordCount+2;
  TC.Cells[0,i]:='<h6><b>Kundenpreise';
  TC.Cells[1,i]:='<h6><b>Verkaufspreis';
  TC.Cells[2,i]:='<h6><b>Rabattsatz';

  if xdsKundenpreise.RecordCount>0 then
  begin

    xdsKundenpreise.First;
    while not xdskundenpreise.eof do
    begin
      inc(i);
      TC.Cells[0,i]:=xdsKundenpreiseArtikelnummerArtikelnummer.AsString+'<br>'+xdsKundenpreiseArtikelnummerArtikelueberschrift.asstring;
      TC.Cells[1,i]:=formatfloat('#,##0.00',xdsKundenpreiseVerkaufspreis.Asfloat);
      TC.Cells[2,i]:=formatfloat('#,##0.00 %',xdsKundenpreiseRabattsatz.Asfloat);
      xdskundenpreise.Next;
    end;
  end;
  I:=0;
  TCEinkauf.ColCount:=3;
  TCEinkauf.Rowcount:=xdsLieferantenpreise.RecordCount+2;
  TCEinkauf.Cells[0,i]:='<h6><b>Lieferantenpreise';
  TCEinkauf.Cells[1,i]:='<h6><b>Einkaufspreis';
  TCEinkauf.Cells[2,i]:='<h6><b>Rabattsatz';
  if xdsLieferantenpreise.RecordCount>0 then
  begin

    xdsLieferantenpreise.First;
    while not xdsLieferantenpreise.eof do
    begin
      inc(i);
      TCEinkauf.Cells[0,i]:=xdsLieferantenpreiseArtikelnummerArtikelnummer.AsString+'<br>'+xdsLieferantenpreiseArtikelnummerArtikelnummer.asstring;
      if xdsLieferantenpreiseArtikelnummerLieferant.AsString<>'' then
      begin
        TCEinkauf.Cells[0,i]:=TCEinkauf.Cells[0,i]+'<br>AN-Lieferant: '+xdsLieferantenpreiseArtikelnummerLieferant.AsString;
      end;
      if xdsLieferantenpreiseMindestbestellmenge.Asfloat>0 then
      begin
        TCEinkauf.Cells[0,i]:=TCEinkauf.Cells[0,i]+'<br>Mindestbestellmenge: '+xdsLieferantenpreiseMindestbestellmenge.AsString;
      end;
      TCEinkauf.Cells[1,i]:=formatfloat('#,##0.00',xdsLieferantenpreiseEinkaufspreis.Asfloat);
      TCEinkauf.Cells[2,i]:=formatfloat('#,##0.00 %',xdsLieferantenpreiseERabattsatz.Asfloat);
      xdsLieferantenpreise.Next;
    end;
  end;


end;

procedure TPreise.LoadDFMValues;
begin
  inherited LoadDFMValues;

  TC := TTableControl.Create(Self);
  Container1 := THTMLContainer.Create(Self);
  btnzurueck := TButton.Create(Self);
  Container2 := THTMLContainer.Create(Self);
  TCEinkauf := TTableControl.Create(Self);
  Container3 := THTMLContainer.Create(Self);
  xdsKundenpreise := TXDataWebDataSet.Create(Self);
  xdsKundenpreiseArtikelnummer := TXDataWebEntityField.Create(Self);
  xdsKundenpreiseKundennummer := TXDataWebEntityField.Create(Self);
  xdsKundenpreiseVerkaufspreis := TFloatField.Create(Self);
  xdsKundenpreiseNachname := TStringField.Create(Self);
  xdsKundenpreiseRabattsatz := TFloatField.Create(Self);
  xdsKundenpreiseVerleihpreis := TFloatField.Create(Self);
  xdsKundenpreiseZusatzPreis := TFloatField.Create(Self);
  xdsKundenpreiseArtikelnummerKunde := TStringField.Create(Self);
  xdsKundenpreiseDatumGeaendert := TDateTimeField.Create(Self);
  xdsKundenpreiseArtikelueberschrift := TStringField.Create(Self);
  xdsKundenpreiseArtikelnummerArtikelnummer := TStringField.Create(Self);
  xdsKundenpreiseArtikelnummerArtikelueberschrift := TStringField.Create(Self);
  xdsKundenpreiseArtikelnummerArtikelbeschreibung := TStringField.Create(Self);
  xdsLieferantenpreise := TXDataWebDataSet.Create(Self);
  xdsLieferantenpreiseArtikelnummer := TXDataWebEntityField.Create(Self);
  xdsLieferantenpreiseKundennummer := TXDataWebEntityField.Create(Self);
  xdsLieferantenpreiseEinkaufspreis := TFloatField.Create(Self);
  xdsLieferantenpreiseNachname := TStringField.Create(Self);
  xdsLieferantenpreiseDatumGeaendert := TDateTimeField.Create(Self);
  xdsLieferantenpreiseArtikelnummerLieferant := TStringField.Create(Self);
  xdsLieferantenpreiseERabattsatz := TFloatField.Create(Self);
  xdsLieferantenpreiseMindestbestellmenge := TFloatField.Create(Self);
  xdsLieferantenpreiseArtikelnummerArtikelnummer := TStringField.Create(Self);
  xdsLieferantenpreiseArtikelnummerArtikelueberschrift := TStringField.Create(Self);
  xdsLieferantenpreiseArtikelnummerArtikelbeschreibung := TStringField.Create(Self);

  TC.BeforeLoadDFMValues;
  Container1.BeforeLoadDFMValues;
  btnzurueck.BeforeLoadDFMValues;
  Container2.BeforeLoadDFMValues;
  TCEinkauf.BeforeLoadDFMValues;
  Container3.BeforeLoadDFMValues;
  xdsKundenpreise.BeforeLoadDFMValues;
  xdsKundenpreiseArtikelnummer.BeforeLoadDFMValues;
  xdsKundenpreiseKundennummer.BeforeLoadDFMValues;
  xdsKundenpreiseVerkaufspreis.BeforeLoadDFMValues;
  xdsKundenpreiseNachname.BeforeLoadDFMValues;
  xdsKundenpreiseRabattsatz.BeforeLoadDFMValues;
  xdsKundenpreiseVerleihpreis.BeforeLoadDFMValues;
  xdsKundenpreiseZusatzPreis.BeforeLoadDFMValues;
  xdsKundenpreiseArtikelnummerKunde.BeforeLoadDFMValues;
  xdsKundenpreiseDatumGeaendert.BeforeLoadDFMValues;
  xdsKundenpreiseArtikelueberschrift.BeforeLoadDFMValues;
  xdsKundenpreiseArtikelnummerArtikelnummer.BeforeLoadDFMValues;
  xdsKundenpreiseArtikelnummerArtikelueberschrift.BeforeLoadDFMValues;
  xdsKundenpreiseArtikelnummerArtikelbeschreibung.BeforeLoadDFMValues;
  xdsLieferantenpreise.BeforeLoadDFMValues;
  xdsLieferantenpreiseArtikelnummer.BeforeLoadDFMValues;
  xdsLieferantenpreiseKundennummer.BeforeLoadDFMValues;
  xdsLieferantenpreiseEinkaufspreis.BeforeLoadDFMValues;
  xdsLieferantenpreiseNachname.BeforeLoadDFMValues;
  xdsLieferantenpreiseDatumGeaendert.BeforeLoadDFMValues;
  xdsLieferantenpreiseArtikelnummerLieferant.BeforeLoadDFMValues;
  xdsLieferantenpreiseERabattsatz.BeforeLoadDFMValues;
  xdsLieferantenpreiseMindestbestellmenge.BeforeLoadDFMValues;
  xdsLieferantenpreiseArtikelnummerArtikelnummer.BeforeLoadDFMValues;
  xdsLieferantenpreiseArtikelnummerArtikelueberschrift.BeforeLoadDFMValues;
  xdsLieferantenpreiseArtikelnummerArtikelbeschreibung.BeforeLoadDFMValues;
  try
    Name := 'Preise';
    Width := 205;
    Height := 436;
    CSSLibrary := cssBootstrap;
    ElementFont := efCSS;
    SetEvent(Self, 'OnShow', 'WebFormShow');
    TC.SetParentComponent(Self);
    TC.Name := 'TC';
    TC.Left := 0;
    TC.Top := 176;
    TC.Width := 121;
    TC.Height := 73;
    TC.ElementClassName := 'table table-hover table-bordered table-striped';
    TC.HeightStyle := ssAuto;
    TC.WidthStyle := ssPercent;
    TC.BorderColor := clSilver;
    TC.ColHeader := False;
    TC.ElementFont := efCSS;
    TC.ElementHeaderClassName := 'table-info';
    TC.ElementPosition := epIgnore;
    TC.ElementTableClassName := 'table table-hover table-bordered table-striped';
    TC.WordWrap := True;
    TC.ColCount := 2;
    Container1.SetParentComponent(Self);
    Container1.Name := 'Container1';
    Container1.Left := 0;
    Container1.Top := 0;
    Container1.Width := 169;
    Container1.Height := 41;
    Container1.HeightStyle := ssAuto;
    Container1.WidthStyle := ssPercent;
    Container1.ChildOrder := 4;
    Container1.ElementFont := efCSS;
    Container1.ElementPosition := epIgnore;
    btnzurueck.SetParentComponent(Self);
    btnzurueck.Name := 'btnzurueck';
    btnzurueck.Left := 0;
    btnzurueck.Top := 145;
    btnzurueck.Width := 96;
    btnzurueck.Height := 25;
    btnzurueck.Caption := '<< zur'#252'ck';
    btnzurueck.ChildOrder := 4;
    btnzurueck.ElementClassName := 'btn btn-info btn-sm m-1 text-left';
    btnzurueck.ElementFont := efCSS;
    btnzurueck.ElementPosition := epIgnore;
    btnzurueck.HeightStyle := ssAuto;
    btnzurueck.HeightPercent := 100.000000000000000000;
    btnzurueck.WidthStyle := ssAuto;
    btnzurueck.WidthPercent := 100.000000000000000000;
    SetEvent(btnzurueck, Self, 'OnClick', 'btnzurueckClick');
    Container2.SetParentComponent(Self);
    Container2.Name := 'Container2';
    Container2.Left := 0;
    Container2.Top := 47;
    Container2.Width := 169;
    Container2.Height := 41;
    Container2.ElementClassName := 'd-flex flex-wrap m-1';
    Container2.HeightStyle := ssAuto;
    Container2.WidthStyle := ssAuto;
    Container2.ChildOrder := 1;
    Container2.ElementFont := efCSS;
    Container2.ElementPosition := epIgnore;
    TCEinkauf.SetParentComponent(Self);
    TCEinkauf.Name := 'TCEinkauf';
    TCEinkauf.Left := 0;
    TCEinkauf.Top := 272;
    TCEinkauf.Width := 121;
    TCEinkauf.Height := 73;
    TCEinkauf.ElementClassName := 'table table-hover table-bordered table-striped';
    TCEinkauf.HeightStyle := ssAuto;
    TCEinkauf.WidthStyle := ssPercent;
    TCEinkauf.BorderColor := clSilver;
    TCEinkauf.ChildOrder := 4;
    TCEinkauf.ColHeader := False;
    TCEinkauf.ElementFont := efCSS;
    TCEinkauf.ElementHeaderClassName := 'table-info';
    TCEinkauf.ElementPosition := epIgnore;
    TCEinkauf.ElementTableClassName := 'table table-hover table-bordered table-striped';
    TCEinkauf.WordWrap := True;
    TCEinkauf.ColCount := 2;
    Container3.SetParentComponent(Self);
    Container3.Name := 'Container3';
    Container3.Left := 0;
    Container3.Top := 94;
    Container3.Width := 169;
    Container3.Height := 41;
    Container3.ElementClassName := 'd-flex flex-wrap m-1';
    Container3.HeightStyle := ssAuto;
    Container3.WidthStyle := ssAuto;
    Container3.ChildOrder := 1;
    Container3.ElementFont := efCSS;
    Container3.ElementPosition := epIgnore;
    xdsKundenpreise.SetParentComponent(Self);
    xdsKundenpreise.Name := 'xdsKundenpreise';
    xdsKundenpreise.AfterOpen := xdsKundenpreiseAfterOpen;
    xdsKundenpreise.EntitySetName := 'ArtikelKundenpreise';
    xdsKundenpreise.Connection := DM2.XDataWebConnection1;
    xdsKundenpreise.SubpropsDepth := 1;
    xdsKundenpreise.QueryString := '$expand=Artikelnummer';
    xdsKundenpreise.Left := 71;
    xdsKundenpreise.Top := 22;
    xdsKundenpreiseArtikelnummer.SetParentComponent(xdsKundenpreise);
    xdsKundenpreiseArtikelnummer.Name := 'xdsKundenpreiseArtikelnummer';
    xdsKundenpreiseArtikelnummer.FieldName := 'Artikelnummer';
    xdsKundenpreiseArtikelnummer.Required := True;
    xdsKundenpreiseKundennummer.SetParentComponent(xdsKundenpreise);
    xdsKundenpreiseKundennummer.Name := 'xdsKundenpreiseKundennummer';
    xdsKundenpreiseKundennummer.FieldName := 'Kundennummer';
    xdsKundenpreiseKundennummer.Required := True;
    xdsKundenpreiseVerkaufspreis.SetParentComponent(xdsKundenpreise);
    xdsKundenpreiseVerkaufspreis.Name := 'xdsKundenpreiseVerkaufspreis';
    xdsKundenpreiseVerkaufspreis.FieldName := 'Verkaufspreis';
    xdsKundenpreiseNachname.SetParentComponent(xdsKundenpreise);
    xdsKundenpreiseNachname.Name := 'xdsKundenpreiseNachname';
    xdsKundenpreiseNachname.FieldName := 'Nachname';
    xdsKundenpreiseNachname.Size := 40;
    xdsKundenpreiseRabattsatz.SetParentComponent(xdsKundenpreise);
    xdsKundenpreiseRabattsatz.Name := 'xdsKundenpreiseRabattsatz';
    xdsKundenpreiseRabattsatz.FieldName := 'Rabattsatz';
    xdsKundenpreiseVerleihpreis.SetParentComponent(xdsKundenpreise);
    xdsKundenpreiseVerleihpreis.Name := 'xdsKundenpreiseVerleihpreis';
    xdsKundenpreiseVerleihpreis.FieldName := 'Verleihpreis';
    xdsKundenpreiseZusatzPreis.SetParentComponent(xdsKundenpreise);
    xdsKundenpreiseZusatzPreis.Name := 'xdsKundenpreiseZusatzPreis';
    xdsKundenpreiseZusatzPreis.FieldName := 'ZusatzPreis';
    xdsKundenpreiseArtikelnummerKunde.SetParentComponent(xdsKundenpreise);
    xdsKundenpreiseArtikelnummerKunde.Name := 'xdsKundenpreiseArtikelnummerKunde';
    xdsKundenpreiseArtikelnummerKunde.FieldName := 'ArtikelnummerKunde';
    xdsKundenpreiseArtikelnummerKunde.Size := 25;
    xdsKundenpreiseDatumGeaendert.SetParentComponent(xdsKundenpreise);
    xdsKundenpreiseDatumGeaendert.Name := 'xdsKundenpreiseDatumGeaendert';
    xdsKundenpreiseDatumGeaendert.FieldName := 'DatumGeaendert';
    xdsKundenpreiseArtikelueberschrift.SetParentComponent(xdsKundenpreise);
    xdsKundenpreiseArtikelueberschrift.Name := 'xdsKundenpreiseArtikelueberschrift';
    xdsKundenpreiseArtikelueberschrift.FieldName := 'Artikelueberschrift';
    xdsKundenpreiseArtikelueberschrift.Size := 50;
    xdsKundenpreiseArtikelnummerArtikelnummer.SetParentComponent(xdsKundenpreise);
    xdsKundenpreiseArtikelnummerArtikelnummer.Name := 'xdsKundenpreiseArtikelnummerArtikelnummer';
    xdsKundenpreiseArtikelnummerArtikelnummer.FieldName := 'Artikelnummer.Artikelnummer';
    xdsKundenpreiseArtikelnummerArtikelnummer.Size := 25;
    xdsKundenpreiseArtikelnummerArtikelueberschrift.SetParentComponent(xdsKundenpreise);
    xdsKundenpreiseArtikelnummerArtikelueberschrift.Name := 'xdsKundenpreiseArtikelnummerArtikelueberschrift';
    xdsKundenpreiseArtikelnummerArtikelueberschrift.FieldName := 'Artikelnummer.Artikelueberschrift';
    xdsKundenpreiseArtikelnummerArtikelueberschrift.Size := 50;
    xdsKundenpreiseArtikelnummerArtikelbeschreibung.SetParentComponent(xdsKundenpreise);
    xdsKundenpreiseArtikelnummerArtikelbeschreibung.Name := 'xdsKundenpreiseArtikelnummerArtikelbeschreibung';
    xdsKundenpreiseArtikelnummerArtikelbeschreibung.FieldName := 'Artikelnummer.Artikelbeschreibung';
    xdsKundenpreiseArtikelnummerArtikelbeschreibung.Size := 255;
    xdsLieferantenpreise.SetParentComponent(Self);
    xdsLieferantenpreise.Name := 'xdsLieferantenpreise';
    xdsLieferantenpreise.AfterOpen := xdsLieferantenpreiseAfterOpen;
    xdsLieferantenpreise.EntitySetName := 'ArtikelLieferantenpreise';
    xdsLieferantenpreise.Connection := DM2.XDataWebConnection1;
    xdsLieferantenpreise.SubpropsDepth := 1;
    xdsLieferantenpreise.QueryString := '$expand=Artikelnummer';
    xdsLieferantenpreise.Left := 71;
    xdsLieferantenpreise.Top := 134;
    xdsLieferantenpreiseArtikelnummer.SetParentComponent(xdsLieferantenpreise);
    xdsLieferantenpreiseArtikelnummer.Name := 'xdsLieferantenpreiseArtikelnummer';
    xdsLieferantenpreiseArtikelnummer.FieldName := 'Artikelnummer';
    xdsLieferantenpreiseArtikelnummer.Required := True;
    xdsLieferantenpreiseKundennummer.SetParentComponent(xdsLieferantenpreise);
    xdsLieferantenpreiseKundennummer.Name := 'xdsLieferantenpreiseKundennummer';
    xdsLieferantenpreiseKundennummer.FieldName := 'Kundennummer';
    xdsLieferantenpreiseKundennummer.Required := True;
    xdsLieferantenpreiseEinkaufspreis.SetParentComponent(xdsLieferantenpreise);
    xdsLieferantenpreiseEinkaufspreis.Name := 'xdsLieferantenpreiseEinkaufspreis';
    xdsLieferantenpreiseEinkaufspreis.FieldName := 'Einkaufspreis';
    xdsLieferantenpreiseNachname.SetParentComponent(xdsLieferantenpreise);
    xdsLieferantenpreiseNachname.Name := 'xdsLieferantenpreiseNachname';
    xdsLieferantenpreiseNachname.FieldName := 'Nachname';
    xdsLieferantenpreiseNachname.Size := 40;
    xdsLieferantenpreiseDatumGeaendert.SetParentComponent(xdsLieferantenpreise);
    xdsLieferantenpreiseDatumGeaendert.Name := 'xdsLieferantenpreiseDatumGeaendert';
    xdsLieferantenpreiseDatumGeaendert.FieldName := 'DatumGeaendert';
    xdsLieferantenpreiseArtikelnummerLieferant.SetParentComponent(xdsLieferantenpreise);
    xdsLieferantenpreiseArtikelnummerLieferant.Name := 'xdsLieferantenpreiseArtikelnummerLieferant';
    xdsLieferantenpreiseArtikelnummerLieferant.FieldName := 'ArtikelnummerLieferant';
    xdsLieferantenpreiseArtikelnummerLieferant.Size := 25;
    xdsLieferantenpreiseERabattsatz.SetParentComponent(xdsLieferantenpreise);
    xdsLieferantenpreiseERabattsatz.Name := 'xdsLieferantenpreiseERabattsatz';
    xdsLieferantenpreiseERabattsatz.FieldName := 'ERabattsatz';
    xdsLieferantenpreiseMindestbestellmenge.SetParentComponent(xdsLieferantenpreise);
    xdsLieferantenpreiseMindestbestellmenge.Name := 'xdsLieferantenpreiseMindestbestellmenge';
    xdsLieferantenpreiseMindestbestellmenge.FieldName := 'Mindestbestellmenge';
    xdsLieferantenpreiseArtikelnummerArtikelnummer.SetParentComponent(xdsLieferantenpreise);
    xdsLieferantenpreiseArtikelnummerArtikelnummer.Name := 'xdsLieferantenpreiseArtikelnummerArtikelnummer';
    xdsLieferantenpreiseArtikelnummerArtikelnummer.FieldName := 'Artikelnummer.Artikelnummer';
    xdsLieferantenpreiseArtikelnummerArtikelnummer.Size := 25;
    xdsLieferantenpreiseArtikelnummerArtikelueberschrift.SetParentComponent(xdsLieferantenpreise);
    xdsLieferantenpreiseArtikelnummerArtikelueberschrift.Name := 'xdsLieferantenpreiseArtikelnummerArtikelueberschrift';
    xdsLieferantenpreiseArtikelnummerArtikelueberschrift.FieldName := 'Artikelnummer.Artikelueberschrift';
    xdsLieferantenpreiseArtikelnummerArtikelueberschrift.Size := 50;
    xdsLieferantenpreiseArtikelnummerArtikelbeschreibung.SetParentComponent(xdsLieferantenpreise);
    xdsLieferantenpreiseArtikelnummerArtikelbeschreibung.Name := 'xdsLieferantenpreiseArtikelnummerArtikelbeschreibung';
    xdsLieferantenpreiseArtikelnummerArtikelbeschreibung.FieldName := 'Artikelnummer.Artikelbeschreibung';
    xdsLieferantenpreiseArtikelnummerArtikelbeschreibung.Size := 255;
  finally
    TC.AfterLoadDFMValues;
    Container1.AfterLoadDFMValues;
    btnzurueck.AfterLoadDFMValues;
    Container2.AfterLoadDFMValues;
    TCEinkauf.AfterLoadDFMValues;
    Container3.AfterLoadDFMValues;
    xdsKundenpreise.AfterLoadDFMValues;
    xdsKundenpreiseArtikelnummer.AfterLoadDFMValues;
    xdsKundenpreiseKundennummer.AfterLoadDFMValues;
    xdsKundenpreiseVerkaufspreis.AfterLoadDFMValues;
    xdsKundenpreiseNachname.AfterLoadDFMValues;
    xdsKundenpreiseRabattsatz.AfterLoadDFMValues;
    xdsKundenpreiseVerleihpreis.AfterLoadDFMValues;
    xdsKundenpreiseZusatzPreis.AfterLoadDFMValues;
    xdsKundenpreiseArtikelnummerKunde.AfterLoadDFMValues;
    xdsKundenpreiseDatumGeaendert.AfterLoadDFMValues;
    xdsKundenpreiseArtikelueberschrift.AfterLoadDFMValues;
    xdsKundenpreiseArtikelnummerArtikelnummer.AfterLoadDFMValues;
    xdsKundenpreiseArtikelnummerArtikelueberschrift.AfterLoadDFMValues;
    xdsKundenpreiseArtikelnummerArtikelbeschreibung.AfterLoadDFMValues;
    xdsLieferantenpreise.AfterLoadDFMValues;
    xdsLieferantenpreiseArtikelnummer.AfterLoadDFMValues;
    xdsLieferantenpreiseKundennummer.AfterLoadDFMValues;
    xdsLieferantenpreiseEinkaufspreis.AfterLoadDFMValues;
    xdsLieferantenpreiseNachname.AfterLoadDFMValues;
    xdsLieferantenpreiseDatumGeaendert.AfterLoadDFMValues;
    xdsLieferantenpreiseArtikelnummerLieferant.AfterLoadDFMValues;
    xdsLieferantenpreiseERabattsatz.AfterLoadDFMValues;
    xdsLieferantenpreiseMindestbestellmenge.AfterLoadDFMValues;
    xdsLieferantenpreiseArtikelnummerArtikelnummer.AfterLoadDFMValues;
    xdsLieferantenpreiseArtikelnummerArtikelueberschrift.AfterLoadDFMValues;
    xdsLieferantenpreiseArtikelnummerArtikelbeschreibung.AfterLoadDFMValues;
  end;
end;

end.